import React from "react";
import "./ToolbarGroup.css";

const ToolbarGroup: React.FC = (props) => {
  const { children } = props;
  return <div className={"ToolbarGroup"}>{children}</div>;
};

export default ToolbarGroup;
